var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') {
    cents = cents.replace('.', '');
  }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
    return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal = defaultOption(decimal, '.');
    if (isNaN(number) || number == null) {
      return 0;
    }
    number = (number / 100.0).toFixed(precision);
    var parts = number.split('.'),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
      cents = parts[1] ? (decimal + parts[1]) : '';
    return dollars + cents;
  }
  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }
  return formatString.replace(placeholderRegex, value);
};

function triggerEvent(el, type) {
  // IE9+ and other modern browsers
  if ('createEvent' in document) {
    var e = document.createEvent('HTMLEvents');
    e.initEvent(type, false, true);
    el.dispatchEvent(e);
  } else {
    // IE8
    var e = document.createEventObject();
    e.eventType = type;
    el.fireEvent('on' + e.eventType, e);
  }
}
var enable_dropdown = $('.enable_dropdown').val();
//automatic active notgift option 1
$('.changing_button').click(function() {
  var checkactiveGift = $('.active__gift').val();
  if (checkactiveGift == "active") {
    var freqvalue = $('.freqvalue').val();
    //$('#frequency_box_ongoing input').trigger("click");
    $('#frequency_box_ongoing').css("display", "none");
    $('#frequency_box').css("display", "flex");
    $('#gift_checkbox').prop('checked', true);
    setTimeout(function() {
      $('#data-variant-option-0').val(freqvalue).trigger("change");
      triggerEvent($('#data-variant-option-0')[0], 'change');
      $('#frequency_box .radio_frequency_selector input').each(function() {
        if ($(this).val() == freqvalue) {
          console.log("vasdvdvad");
          $('#rc_container .rc_radio__autodeliver').trigger("click");
          var frequency = freqvalue.split(" ")[0];
          $('#rc_charge_interval_frequency').val(frequency);
          $(this).prop('checked', true);
          $(this).parent().parent().addClass("active_div");
        }
      });
    }, 1000);
  } else {
    setTimeout(function() {
      var firstselector = $('.changing_button_val').val();
      // console.log(firstselector);
      var frequency = firstselector.split(" ")[0];
      $('#rc_charge_interval_frequency').val(frequency);
      $('#rc_number_charges_until_expiration').attr("name", "");
      $('#data-variant-option-0').val(firstselector).trigger("change");
      $('#data-variant-option-0').val(firstselector).trigger("change");
      $('#data-variant-option-0').val(firstselector).trigger("change");
      triggerEvent($('#data-variant-option-0')[0], 'change');
      $('#data-variant-option-0').val(firstselector).trigger("click");
    }, 1000);
  }
});
$('#frequency_box_ongoing .radio_wrapper').each(function(i) {
  if (i == 0) {
    var checkactiveGift = $('.active__gift').val();
    if (checkactiveGift == "active") {
      $('.changing_button').trigger("click");
    } else {
      $(this).addClass("active_div");
      $(this).find('input').trigger("click");
      $(this).find('input').trigger("click");
      $(this).find('input').trigger("click");
      var firstselector = $(this).find('input').val();
      $('.changing_button_val').val(firstselector);
      $('.changing_button').trigger("click");
    }
  }
});

$('input[name="checkGift"]').change(function() {
  if ($(this).is(":checked")) {
    $('.product__information .subscription-modal .form__tab').removeClass('checked');
    $(this).closest('label').addClass('checked');
    if ($(this).val() == "gift") {
      // $(this).prop('checked', false);
      $('#gift_checkbox').prop('checked', true);
      //frequency enabled
      $('#frequency_box').css("display", "flex");
      //ongoing disabled
      $('#frequency_box_ongoing').css("display", "none");
      $('input:checkbox[name="frequency_ongoing"]').each(function() {
        $(this).prop('checked', false);
        $('input:checkbox[name="frequency_ongoing"]').parent('.radio_div').parent('.radio_wrapper').removeClass('active_div');
      });
      $('#rc_container .rc_radio__autodeliver').trigger("click");
      //automatic active gift option 1
      $('#frequency_box .radio_wrapper').each(function(i) {
        if (i == 0) {
          $(this).addClass("active_div");
          $(this).find('input').trigger("click");
          var firstselector = $(this).find('input').val();
          $('#data-variant-option-0').val(firstselector).trigger("change");
          triggerEvent($('#data-variant-option-0')[0], 'change');
          $('#rc_container .rc_radio__onetime').trigger("click");
          $('#rc_shipping_interval_frequencys').attr("name", "");
          $('#rc_charge_interval_unit_type').attr("name", "");
          $('#rc_charge_interval_frequency').attr("name", "");
          $('#rc_number_charges_until_expiration').attr("name", "");
        }
      });
    } else {
      //frequency disabled
      $('#frequency_box').css("display", "none");
      $('input:checkbox[name="frequency"]').each(function() {
        $(this).prop('checked', false);
        $('input:checkbox[name="frequency"]').parent('.radio_div').parent('.radio_wrapper').removeClass('active_div');
      });
      //ongoing enabled
      $('#frequency_box_ongoing').css("display", "flex");
      $('input:checkbox[name="frequency_ongoing"]').each(function() {
      });
      //ReCharge
      $('#rc_container .rc_radio__autodeliver').trigger("click");
      //automatic active gift option 1
      $('#frequency_box_ongoing .radio_wrapper').each(function(i) {
        if (i == 0) {
          $(this).addClass("active_div");
          $(this).find('input').trigger("click");
          var firstselector = $(this).find('input').val();
          $('#data-variant-option-0').val(firstselector).trigger("change");
          triggerEvent($('#data-variant-option-0')[0], 'change');
          var frequency = firstselector.split(" ")[0];
          $('#rc_charge_interval_frequency').val(frequency);
          setTimeout(function() {
            $('.compare__prices').html($('#comparePrice-product-template').html());
          }, 500);
        }
      });
    }
  } else {
    //frequency disabled
    $('#frequency_box').css("display", "none");
    $('input:checkbox[name="frequency"]').each(function() {
      $(this).prop('checked', false);
      $('input:checkbox[name="frequency"]').parent('.radio_div').parent('.radio_wrapper').removeClass('active_div');
    });
    //ongoing enabled
    $('#frequency_box_ongoing').css("display", "flex");
    $('input:checkbox[name="frequency_ongoing"]').each(function() {
    });
    //ReCharge
    $('#rc_container .rc_radio__autodeliver').trigger("click");
    $('#rc_shipping_interval_frequencys').attr("name", "properties[shipping_interval_frequency]");
    $('#rc_charge_interval_unit_type').attr("name", "properties[charge_interval_unit_type]");
    $('#rc_charge_interval_frequency').attr("name", "properties[charge_interval_frequency]");
    console.log($('#comparePrice-product-template').html());
    setTimeout(function() {
      $('.compare__prices').html($('#comparePrice-product-template').html());
    }, 500);
    $('#rc_number_charges_until_expiration').attr("name", "");
    //automatic active gift option 1
    $('#frequency_box_ongoing .radio_wrapper').each(function(i) {
      if (i == 0) {
        $(this).addClass("active_div");
        $(this).find('input').trigger("click");
        var firstselector = $(this).find('input').val();
        $('#data-variant-option-0').val(firstselector).trigger("change");
        triggerEvent($('#data-variant-option-0')[0], 'change');
        var frequency = firstselector.split(" ")[0];
        $('#rc_charge_interval_frequency').val(frequency);
        console.log($('#comparePrice-product-template').html());
        setTimeout(function() {
          $('.compare__prices').html($('#comparePrice-product-template').html());
        }, 500);
      }
    });
  }
  $('#frequency_box_ongoing .radio_wrapper').matchHeight();
  $('#frequency_box .radio_wrapper').matchHeight();
  generatePrice();
});
var checkboxes = document.querySelectorAll('#addons_box .addon_wrapper input[type="checkbox"]');
if (checkboxes) {
  for (var i = 0; i < checkboxes.length; i++) {
    checkboxes[i].addEventListener('click', function() {
      if ($(this).is(":checked")) {
        $(this).parent('.radio_div').parent('.addon_radio_wrapper').addClass('active_div');
        $(this).parent('.radio_div').parent('.addon_radio_wrapper').parent('.product_addon_title').prev('.img_div').children('.img_wrapper').addClass('active_div');
      } else {
        $(this).parent('.radio_div').parent('.addon_radio_wrapper').removeClass('active_div');
        $(this).parent('.radio_div').parent('.addon_radio_wrapper').parent('.product_addon_title').prev('.img_div').children('.img_wrapper').removeClass('active_div');
      }
      generatePrice();
    });
  }
}
$('#addons_box .addon_wrapper input[type="checkbox"]').change(function() {
  if ($(this).is(":checked")) {
    $(this).parent('.radio_div').parent('.addon_radio_wrapper').addClass('active_div');
    $(this).parent('.radio_div').parent('.addon_radio_wrapper').parent('.product_addon_title').prev('.img_div').children('.img_wrapper').addClass('active_div');
  } else {
    $(this).parent('.radio_div').parent('.addon_radio_wrapper').removeClass('active_div');
    $(this).parent('.radio_div').parent('.addon_radio_wrapper').parent('.product_addon_title').prev('.img_div').children('.img_wrapper').removeClass('active_div');
  }
  generatePrice();
});
//Frequency Gift OnChange
$('input:radio[name="frequency"]').change(function() {
  if ($(this).is(":checked")) {
    $('input:radio[name="frequency"]').parent('.radio_div').parent('.radio_wrapper').removeClass('active_div');
    $(this).parent('.radio_div').parent('.radio_wrapper').addClass('active_div');
    //Option 1 Value
    var realValue = $(this).val();
    var frequency = realValue.split(" ")[0];
    $('#data-variant-option-0').val(realValue).trigger("change");
    triggerEvent($('#data-variant-option-0')[0], 'change');
    //$('#rc_container .rc_radio__onetime').trigger("click");
    if (realValue == "1 month") {
      $('#rc_container .rc_radio__onetime').trigger("click");
      $('#rc_shipping_interval_frequencys').attr("name", "");
      $('#rc_charge_interval_unit_type').attr("name", "");
      $('#rc_charge_interval_frequency').attr("name", "");
      $('#rc_number_charges_until_expiration').attr("name", "");
    } else {
      $('#rc_container .rc_radio__autodeliver').trigger("click");
      $('#rc_shipping_interval_frequencys').attr("name", "properties[shipping_interval_frequency]");
      $('#rc_charge_interval_unit_type').attr("name", "properties[charge_interval_unit_type]");
      $('#rc_charge_interval_frequency').attr("name", "properties[charge_interval_frequency]");
      $('#rc_number_charges_until_expiration').attr("name", "properties[number_charges_until_expiration]");
      $('#rc_charge_interval_frequency').val(frequency);
    }
  }
  generatePrice();
});
//Frequency NotGift OnChange
$('input:radio[name="frequency_ongoing"]').change(function() {
  if ($(this).is(":checked")) {
    $('input:radio[name="frequency_ongoing"]').parent('.radio_div').parent('.radio_wrapper').removeClass('active_div');
    $(this).parent('.radio_div').parent('.radio_wrapper').addClass('active_div');
    var realValue = $(this).val().split(" ");
    var frequency = realValue[0];
    $('#rc_charge_interval_frequency').val(frequency);
    //Change ReCharge value
    $('select[name="properties[shipping_interval_frequency]"]').val(realValue[0]);
    $('#data-variant-option-0').val($(this).val()).trigger("change");
    triggerEvent($('#data-variant-option-0')[0], 'change');
    $('#rc_container .rc_radio__autodeliver').trigger("click");
  }
  generatePrice();
});
var discountPrice = $('.rc_label__discount').attr('data-discountpercent');
$('#frequency_box_ongoing .price_tag').text();
$('#fakeCheckOut').click(function() {
  var text_fullname = $('#text_fullname').val();
  var bday_datepicker = $('#bday_datepicker').val();
  //if (text_fullname != "" && text_fullname != " " && text_fullname != null && bday_datepicker != "") {
  $('#hiddenFname').val(text_fullname);
  $('#hiddenBday').val(bday_datepicker);
  //Submit button
  setTimeout(function() {
    $('.purchase-details .button--add-to-cart').trigger("click");
  }, 600);
});

$('.product__information .modal_price .price-ui').on('updatePrice', function () {
  $('.subscription-modal .addOnSubTotal').html($('.product__information .modal_price').html());
})
function generatePrice() {
  // var $active = $('.radio_frequency_selector.active_div:visible');
  // var price = Number($active.data('price'));
  // var months = $active.data('months');
  // var radioText = $('.radio_frequency_selector.active_div:visible .radio_text').text().split('Save')[0].replace(/\s+/g, ' ').trim();
  // var addon = 0;
  // var $addons = $('#addons_box input:checked');
  // for (var i = 0; i < $addons.length; i++) {
  //   addon += Number($addons.get(i).dataset.price);
  // }
  // var $subTotal = $('.SubTotal');
  // $subTotal.find('.price').text(Shopify.formatMoney(price));
  // $subTotal.find('span').text(radioText.split('/').join('/ ' + months + 'x '));
  // $('.addOnPrice_total .price').text(Shopify.formatMoney(addon));
  // var total = price + addon;
  // $('.addOnSubTotal .money').text(Shopify.formatMoney(total));
}
// Date Picker for Forms
$(document).ready(function() {
  $(function() {
    $("#bday_datepicker").datepick({
      showOtherMonths: true,
      selectOtherMonths: true,
      dateFormat: 'dd-mm-yy'
    });
  });
});

$('#data-variant-option-0').change(function() {
  generatePrice();
}).change();
//for enable dropdown selector
if (enable_dropdown) {
  var typeValue = $('.recurring_active .Type_option select').val();
  var typeLowerCase = typeValue.toLowerCase();
  var replaceSpace = typeLowerCase.split(' ').join('-');
  $('.' + replaceSpace + '_radio').css("display", "block");
  $('.recurring_active .Type_option select').change(function() {
    var typeValue = $(this).val();
    var typeLowerCase = typeValue.toLowerCase();
    var replaceSpace = typeLowerCase.split(' ').join('-');
    console.log(replaceSpace)
    $('.radio_frequency_selector').css("display", "none");
    $('.' + replaceSpace + '_radio').css("display", "block");
    $('.radio_frequency_selector').removeClass("open_radio");
    $('.' + replaceSpace + '_radio').addClass("open_radio");
    $('#collapsible-length input:visible').eq(0).click();
  });
  $('input[name="checkGift"]').change(function() {
    if ($(this).is(":checked")) {
      if ($(this).val() == "nonegift") {
      } else {
        var typeValue = $('.recurring_active .Type_option select').val();
        var typeLowerCase = typeValue.toLowerCase();
        var replaceSpace = typeLowerCase.split(' ').join('-');
        $('#frequency_box .' + replaceSpace + '_radio').first().addClass('active_div');
        $('#frequency_box .' + replaceSpace + '_radio').first().find('input').trigger("click");
      }
    } else {
    }
    $('#collapsible-length input:visible').eq(0).click();
  });
} else {
}
$('.collapsible__button').on('click', function() {
  $('#' + this.dataset.collapse).toggleClass('is-collapsed');
  $(this).closest('.collapsible').toggleClass('is-collapsed');
  $(this).toggleClass('is-collapsed');
});
$('.subscription-button').on('click', function() {
  $('.subscription-modal').fadeIn();
  generatePrice();
  $('body').addClass('no-overflow');
  $('.subscription-modal .padding-scroll').css('height', $('.subscription-modal .wrapper').outerHeight());
});
$.fn.matchHeight._afterUpdate = function(event, groups) {
  $('.subscription-modal .padding-scroll').css('height', $('.subscription-modal .wrapper').outerHeight());
}
$('.subscription-modal__close').on('click', function() {
  $('.subscription-modal').fadeOut();
  $('body').removeClass('no-overflow');
});
$('.subscription-modal').mouseup(function(e) {
  var container = $(".subscription-modal .wrapper");
  // if the target of the click isn't the container nor a descendant of the container
  if (!container.is(e.target) && container.has(e.target).length === 0) {
    $('.subscription-modal').fadeOut();
    $('body').removeClass('no-overflow');
  }
});
$('#frequency_box_ongoing .radio_wrapper').matchHeight();
$('#frequency_box .radio_wrapper').matchHeight();
var resizeTimer;
$(window).on('resize', function () {
  if ($('body').hasClass('no-overflow')) {
    $('.subscription-modal .padding-scroll').css('height', $('.subscription-modal .wrapper').outerHeight());
  }
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(function() {
    $('#frequency_box_ongoing .radio_wrapper').matchHeight();
    $('#frequency_box .radio_wrapper').matchHeight();
  }, 400);
})


var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
if (isSafari) { 
  $('body').addClass('is-safari');
}

$(document).ready(function () {
  if ($('body.product').length) {
    if ($('.block__product-boxfinder').length) {
      $('.to-box-finder').attr('href', '#'+$('.block__product-boxfinder').attr('id')).removeClass('hidden');
      $('.to-box-finder').click(function () {
        $('html,body').animate({
            scrollTop: $('.block__product-boxfinder').offset().top - 100
        }, 500);
        return false;
      })
    }
  }
})